<template>
  <z-dialog :show="isVisible" :modal-size="modalSize">
    <template #header>
      <div class="custom-header">
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">{{ title }}</h4>
          </div>
          <div class="col-md-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div>
        <p style="text-align: center">
          Our pricing is simple: choose a subscription plan that works for you and pay per transaction based on your monthly usage.
        </p>

        <div class="subscription">
          <h4>Subscription Plans</h4>
          <h5>$20/month or $200/year</h5>
          <h5>With Auto-Fill: $40/month or $400/year</h5>
          <p>Includes access to our platform and tools. Transaction fees apply as outlined below.</p>
        </div>
        <div class="subscription">
          <h4>Transaction Pricing</h4>
        </div>
        <table class="pricing-table">
          <thead>
            <tr>
              <th>Range</th>
              <th>Rate</th>
              <th>Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1 - 50</td>
              <td>$0.50</td>
              <td>Tiered Pricing</td>
              <td>$0.50 per invoice for the first 50 invoices</td>
            </tr>
            <tr>
              <td>51 - 500</td>
              <td>$0.40</td>
              <td>Tiered Pricing</td>
              <td>$0.40 per invoice for invoice between 51-500</td>
            </tr>
            <tr>
              <td>501 - 1000</td>
              <td>$0.35</td>
              <td>Tiered Pricing</td>
              <td>$0.35 per invoice for invoices between 501-1000</td>
            </tr>
            <tr>
              <td>1001 - 5000</td>
              <td>$0.25</td>
              <td>Tiered Pricing</td>
              <td>$0.25 per invoice for invoices between 1001-5000</td>
            </tr>
            <tr>
              <td>5001+</td>
              <td>$0.15</td>
              <td>Tiered Pricing</td>
              <td>$0.15 per invoice for invoices 5000+</td>
            </tr>
          </tbody>
        </table>

        <p style="text-align: center">
          Not sure which pricing model fits you best? <a href="mailto:info@jingleenterprises.com">Contact us</a> and we’ll help you choose the right
          plan for your needs.
        </p>
      </div>
    </template>
    <template #footer>
      <button type="button" class="btn btn-light" @click="close()">Okay</button>
    </template>
  </z-dialog>
</template>
<script>
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'DialogPricing',
  components: {
    ZDialog
  },
  props: {
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: 'modal-md'
    }
  },
  emits: ['input', 'closing', 'send'],
  computed: {
    isVisible: {
      get() {
        let _is = false
        if (this.modelValue) {
          _is = true
        }
        return _is
      }
    },
    title() {
      let _data = null
      if (this.modelValue) {
        _data = this.modelValue.title
      }
      return _data
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-subtitle {
  font-size: 0.9em;
}

.container {
  max-width: 900px;
  margin: auto;
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
h1,
h2 {
  text-align: center;
}
.pricing-table {
  width: 100%;
  border-collapse: collapse;
  margin: 2rem 0;
}
.pricing-table th,
.pricing-table td {
  border: 1px solid #ddd;
  padding: 0.75rem;
  text-align: left;
}
.pricing-table th {
  background-color: #f0f0f0;
}
.subscription {
  text-align: center;
  margin-bottom: 2rem;
}
.subscription h3 {
  margin-bottom: 0.5rem;
}
.highlight {
  background-color: #e6f7ff;
}
</style>
